export const makeFormData = (program, values) => {
    let programData = {  organization_id: program.organization_id,
        program_id: program.id,};

    if (values.cascading_approval_min_threshold !== undefined) {
        programData.cascading_approval_min_threshold =
            values.cascading_approval_min_threshold;
    }
     // Include invite/award ONLY if explicitly passed OR needed
    if (
        values.hasOwnProperty('allow_award_new_participant') ||
        values.hasOwnProperty('program_managers_can_invite_participants')
    ) {
        programData.allow_award_new_participant =
            values.allow_award_new_participant ?? program.allow_award_new_participant;

        programData.program_managers_can_invite_participants =
            values.program_managers_can_invite_participants ?? program.program_managers_can_invite_participants;
    }
    if (values.hasOwnProperty('allow_credit_card_payments')) {
        programData.allow_credit_card_payments =
            values.allow_credit_card_payments ?? program.allow_credit_card_payments;
    }
    return programData
}